import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  constructor(private currentUserService: CurrentUserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const returnUrl = route.queryParamMap.get('returnUrl');

    return this.currentUserService.currentUser.pipe(
      take(1),
      map(result => {
        if (result && result.currentUser) {
          const target = returnUrl && returnUrl !== '/login' ? returnUrl : '/';
          return this.router.createUrlTree([target]);
        }
        return true;
      })
    );
  }
}